export class TdoTableRowModel {
  model: any;
  isSelected: boolean;
  index: number;
}
